namespace $.$$ {

	type $shm_tests_benchmark_table_row = {
		id: string
		step: string
		benchmark: string
		values: Map< string, string >
	}

	export class $shm_tests_benchmark_table extends $.$shm_tests_benchmark_table {

		data() {
			return this.results() as readonly $shm_tests_app_result[]
		}

		runs() {
			return this.data().slice( 0, 3 )
		}

		step_only() {
			return Boolean( this.step_title() )
		}

		steps( result: $shm_tests_app_result ) {
			if( !this.step_only() ) return result.steps
			const exact = result.steps.find( step => step.title === this.step_title() )
			if( exact ) return [ exact ]
			const fallback = result.steps[ this.step_index() ]
			return fallback?.title === this.step_title() ? [ fallback ] : []
		}

		benchmark_value( benchmark: $shm_tests_app_benchmark ) {
			const digits = Math.abs( benchmark.value ) < 10 ? 2 : 1
			const value = benchmark.value.toFixed( digits ).replace( /\.0+$/, '' )
			return `${ value } ${ benchmark.unit === 'ms' ? 'мс' : benchmark.unit }`
		}

		benchmark_rows() {
			const rows = new Map< string, $shm_tests_benchmark_table_row >()
			for( const result of this.runs() ) {
				for( const step of this.steps( result ) ) {
					const step_number = result.steps.indexOf( step ) + 1
					for( const benchmark of step.benchmarks ?? [] ) {
						const id = JSON.stringify([ step.title, benchmark.title, benchmark.unit ])
						let row = rows.get( id )
						if( !row ) {
							row = {
								id,
								step: String( step_number ),
								benchmark: benchmark.title,
								values: new Map,
							}
							rows.set( id, row )
						}
						row.values.set( result.run.id, this.benchmark_value( benchmark ) )
					}
				}
			}
			return [ ... rows.values() ]
		}

		override has_benchmarks() {
			return this.benchmark_rows().length > 0
		}

		override table_columns() {
			return [
				...( this.step_only() ? [] : [ 'step' ] ),
				'benchmark',
				... this.runs().map( result => result.run.id ),
			]
		}

		override column_title( id: string ) {
			if( id === 'step' ) return [ 'Шаг' ]
			if( id === 'benchmark' ) return [ 'Бенчмарк' ]
			const result = this.runs().find( result => result.run.id === id )
			if( !result ) return [ id ]
			const target = result.targets.find( target => target.role === 'browser_app' ) ?? result.targets[ 0 ]
			const version = target?.app_version || 'unknown'
			const date = new Date( result.run.started_at ).toLocaleString( 'ru-RU' )
			return [ `${ version } · ${ date }` ]
		}

		override table_records() {
			return Object.fromEntries( this.benchmark_rows().map( row => [ row.id, {
				step: row.step,
				benchmark: row.benchmark,
				... Object.fromEntries( this.runs().map( result => [
					result.run.id,
					row.values.get( result.run.id ) ?? '—',
				] ) ),
			}] ) )
		}

	}

}
